import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfidentialModalModule } from '@app/modals/confidential-modal/confidential-modal.module';
import { DirectivesModule } from '@app/modules/directives.module';
import { EmojiButtonComponent } from '@app/modules/emoji-button/emoji-button.component';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { IonicModule } from '@ionic/angular';
import { ContentTitleModule } from '../content-title/content-title.module';
import { NegativeFeedbackQuestionComponent } from './negative-feedback-question.component';

@NgModule({
  declarations: [NegativeFeedbackQuestionComponent],
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    EmojiButtonComponent,
    ConfidentialModalModule,
    FullHeightContainerModule,
    ContentTitleModule
  ],
  exports: [NegativeFeedbackQuestionComponent]
})
export class NegativeFeedbackQuestionModule {}
